import Vue from 'vue';
import Vuex from 'vuex';
import common from './modules/common'
import site from './modules/site'
import partner from './modules/partner'
import recharge from './modules/recharge'
import inbound from './modules/inbound'
import packageslist from './modules/packageslist'
import mail from './modules/mail'
import cash from './modules/cash'
import dashboard from './modules/dashboard'
import customer from './modules/customer'

import fetch from '../plugins/axios'
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    common,
    site,
    partner,
    recharge,
    inbound,
    packageslist,
    mail,
    cash,
    dashboard,
    customer,
  },
  state: {
    excom: [], //快递公司
    baseInfo: {
      userInfo: {},
    }, //基础信息
    dictionaries: {}, //字典
    newWaterStatus: 0 //新的流水记录条数
  },
  getters: {
    type: ( state:any ) => state.site.info.type,
    water: ( state:any ) => {
      if(state.site.info.type != 1){
        if(state.site.info.wash != 0){
          return true
        }else{
          return false
        }
      }else{
        return true
      }
    },
    role: ( state:any ) => state.baseInfo.userInfo.role,
  },
  mutations: {
    setState(state:any,{ key, data }){
			state[key] = data;
		}
  },
  actions: {
    async login({ commit }: any, params: any) {
      return await fetch({
        url: '/oauth2/token',
        method: 'post',
        data: {...params,client_id:'web',client_secret:'90c92b2105c2e4d2afc8c6efd0aca6a5',grant_type:'password',scope:'state'}
      })
      
    },
    // 获得快递公司
    async getExcom({ commit }: any, params: any) {
			const res = await fetch({
        url: '/common/getExcom'
      })
      commit('setState',{key:'excom',data:res})
    },
    // 获取基础信息
    async getBaseInfo({ commit }: any, params: any) {
			const res = await fetch({
        url: '/client/baseInfo'
      })
      commit('setState',{key:'baseInfo',data:res})
    },
    // initData
    async initData({ dispatch }) {
      await dispatch('getBaseInfo');
      await dispatch('site/getCheckAuth');
    },
    // 获取字典信息
    async getDictionaries({ commit }: any, params: any) {
			const res = await fetch({
        url: '/common/dictionaries'
      })
      commit('setState',{key:'dictionaries',data:res})
    },
    // 获取新的流水记录状态
    async getNewWaterStatus({ commit }: any, params: any) {
			const res = await fetch({
        url: '/client/cash/activeNum'
      })
      console.log(res);
      
      commit('setState',{key:'newWaterStatus',data:res})
    }
  },
});
